var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"banner_img",on:{"click":function($event){_vm.o-_vm.click}}},[_c('img',{attrs:{"src":require("../static/images/head_bg2.gif"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }